import { CopilotPanelContentBase, CopilotPanelContext } from 'models/copilot/copilotBridge';
import { CopilotPanelContextDefinition } from 'models/copilot/copilotPanelContextDefinition';
import { CopilotTrialWelcomeContent } from 'models/copilot/copilotTrialWelcome';

export class CopilotTrialWelcomePanelContextDefinition extends CopilotPanelContextDefinition {
  constructor() {
    super();
    this.context = CopilotPanelContext.TrialWelcome;
    this.name = 'TrialWelcome';
    this.forceOpen = true;
    this.forcePinned = true;
  }

  isAvailableForContent(content: CopilotPanelContentBase | undefined): boolean {
    return content instanceof CopilotTrialWelcomeContent && content.context === this.context;
  }
}
